import React from "react"

interface SoldxPageHeroProps {
  /** Page title (can be string or JSX e.g. with <strong>) */
  title: React.ReactNode
  /** Rendered under the title (e.g. breadcrumb on Explore Properties) */
  belowTitle?: React.ReactNode
  /** Show prev/next arrows below title */
  showArrows?: boolean
  /** Smaller height for inner pages */
  compact?: boolean
}

const SoldxPageHero: React.FC<SoldxPageHeroProps> = ({
  title,
  belowTitle,
  showArrows = false,
  compact = false,
}) => {
  return (
    <section className={`soldx-hero ${compact ? "soldx-hero--compact" : ""}`}>
      <div className="soldx-hero-bg" />
      <div className="soldx-hero-content">
        <h1 className="soldx-hero-title">{title}</h1>
        {belowTitle}
        {showArrows && (
          <div className="soldx-hero-arrows">
            <button type="button" className="soldx-hero-arrow" aria-label="Previous">
              <i className="bx bx-chevron-left" />
            </button>
            <button type="button" className="soldx-hero-arrow" aria-label="Next">
              <i className="bx bx-chevron-right" />
            </button>
          </div>
        )}
      </div>
    </section>
  )
}

export default SoldxPageHero
